import { Component, Input } from '@angular/core';
import { SystemAnnouncement } from '../system-announcements.types';
import { SystemAnnouncementService } from '../system-announcements.service';
import { decodeBase64, encodeBase64 } from 'src/app/common/util/utilities';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'system-announcement-sidebar',
  templateUrl: './announcement-sidebar.component.html',
  styleUrl: './announcement-sidebar.component.css'
})
export class AnnouncementSidebarComponent {
  @Input({ required: false }) isAdd: boolean = true;
  @Input({ required: false }) details?: SystemAnnouncement;
  @Input({ required: true }) onClose: Function = () => {};

  sidebarVisible = true;
  isSaving = false;

  id?: string;
  title = '';
  content = '';

  // errorMsg = '';

  constructor(private dataService: SystemAnnouncementService, private readonly msgService: MessageService) {}

  get isValid() {
    return this.title?.trim();
  }

  ngOnInit(): void {
    if (this.details) {
      this.id = this.details.id;
      this.title = this.details.title;
      this.content = decodeBase64(this.details.content);
    }
  }

  onContentChange = (contentData: any) => {
    this.content = contentData;
  };

  onSaveAnnouncement = () => {
    this.isSaving = true;
    try {
      const payload = { title: this.title?.trim(), content: encodeBase64(this.content) } as SystemAnnouncement;
      this.dataService.saveAnnouncements(payload, this.id).subscribe({
        next: (res: any) => {
          this.isSaving = false;
          this.onClose(true);
        },
        error: (err) => {
          this.isSaving = false;
          // this.errorMsg = err?.error?.message;
          this.sendMsg('error', err?.error?.message);
        }
      });
    } catch (error) {
      this.sendMsg('error', error as string);
    }
  };

  sendMsg = (type: string, msg: string, detail = '') => {
    const errorTitle = msg || 'Something went wrong';
    this.msgService.add({ severity: type, summary: errorTitle, detail, closable: true });
  };
}
